import styled from 'styled-components';

export const Button = styled.button`
    border-radius: 15px;
    background: #DF6B78;
    height: 25px;
    position: absolute;
    left: 50%;

    `;


